import moment from "moment";

export const showPrettyTime = (seconds: number) => {
  if (!seconds || seconds === 0) return "";
  return moment.duration(seconds, "seconds").format("d [d,] h [h,] m [m]", { trim: "both final" });
};
